import enCardIssue from './cardIssue.i18n.json';

export const cardIssue = {
  en: enCardIssue,
};
